/**
 * Offers Animation Module
 * Anime les cartes d'offres au scroll avec GSAP
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class OffersAnimation {
  constructor() {
    this.cards = document.querySelectorAll('.offer-card');
    
    if (this.cards.length > 0) {
      this.init();
    }
  }

  init() {
    this.cards.forEach((card, index) => {
      gsap.to(card, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
        delay: index * 0.1,
      });
    });
  }
}
